import { ChevronDown, ChevronRight, File, Folder } from 'react-feather';
import React from 'react';
import { Checkbox, CircularProgress } from '@mui/material';
import { TreeItemProps } from '../kb.props';
import { truncateData } from '../../../../services';
import StyledTooltip from '../../../../components/tooltip';
import '../../../../index.css';

function TreeItem({
  key,
  node,
  level,
  folderId,
  onCheckboxChange,
  onToggle,
  service,
  showCheckboxes,
  disabled,
}: TreeItemProps) {
  const isCurrentNodeExpanded = node.isExpanded;
  const hasChildren = node.mimeType?.includes('folder');

  return (
    <div className="select-none" key={key}>
      <React.Fragment key={node.id}>
        {' '}
        <div
          className="flex items-center py-0.5 hover:bg-gray-50 transition-colors duration-150 text-sm"
          style={{ paddingLeft: `${level * 20 + 8}px` }}
        >
          {hasChildren && node && showCheckboxes && (
            <div className="flex-shrink-0 w-4 h-4 mr-2 allCheck">
              {showCheckboxes && (
                <Checkbox
                  id={node.id}
                  key={node.id}
                  disabled={disabled}
                  checked={!!node.checked}
                  indeterminate={!!node.indeterminate}
                  onChange={(_, c) => onCheckboxChange?.(c, node.id)}
                  className="border-[#101828s] border-[2px] w-[16px] h-[16px] hover:cursor-pointer"
                />
              )}
            </div>
          )}
          <div className="flex-shrink-0 w-4 h-4 flex items-center justify-center mr-1">
            {hasChildren ? (
              <button
                type="button"
                disabled={disabled}
                className="w-4 h-4 flex items-center justify-center bg-transparent border-none p-0 focus:outline-none"
                onClick={() => onToggle?.(node.id)}
                aria-label={`${isCurrentNodeExpanded ? 'Collapse folder' : 'Expand folder'}`}
              >
                {isCurrentNodeExpanded ? (
                  <ChevronDown size={12} className="text-gray-600" />
                ) : (
                  <ChevronRight size={12} className="text-gray-600" />
                )}
              </button>
            ) : null}
          </div>

          {!hasChildren && <div className="mr-1 w-4 h-4" />}

          <div className="flex-shrink-0 mr-2">
            {hasChildren ? (
              <Folder
                size={14}
                className={` fill-blue-100 ${disabled ? 'text-gray-800' : 'text-blue-700'}`}
              />
            ) : (
              <File size={14} className="text-gray-500" />
            )}
          </div>

          <StyledTooltip
            title={service === 'aws' ? node.name || node.file_name || '' : node.name || ''}
          >
            <span className="text-gray-700 text-sm font-normal truncate">
              {truncateData(
                service === 'aws' ? node.name || node.file_name || '' : node.name || '',
                20,
              )}
            </span>
          </StyledTooltip>
        </div>
        {isCurrentNodeExpanded && (
          <div>
            {node.isLoading && (
              <div style={{ paddingLeft: `${(level + 1) * 20 + 8}px` }}>
                <CircularProgress size={12} />
              </div>
            )}
            {!node.isLoading &&
              node.children &&
              node.children.length > 0 &&
              node.children.map((c) => (
                <TreeItem
                  key={c.id}
                  node={c}
                  level={level + 1}
                  onToggle={onToggle}
                  folderId={folderId}
                  onCheckboxChange={onCheckboxChange}
                  showCheckboxes={showCheckboxes}
                  service={service}
                />
              ))}
            {!node.isLoading && node.children && node.children.length === 0 && (
              <div
                className="text-xs text-gray-400 italic"
                style={{ paddingLeft: `${(level + 1) * 20 + 8}px` }}
              >
                No files in this folder
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    </div>
  );
}

TreeItem.defaultProps = {
  service: '',
};

export default TreeItem;
